const userFields = [
  {
    name: "name",
    label: "Name",
    type: "text",
    placeholder: "Type Name",
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    placeholder: "Type Email",
  },
  {
    name: "phone_number",
    label: "Phone Number",
    type: "phone",
    placeholder: "9xx-xxx-xxxx",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Type Password",
  },
  {
    name: "password_confirmation",
    label: "Confirm Password",
    type: "password",
    placeholder: "Type Confirmation Password",
  },
  {
    name: "twoFactorAuth",
    label: "Toggle 2FA",
    type: "toggle",
    placeholder: "Toggle 2FA",
  },
  {
    name: "lang",
    label: "Language",
    type: "radio",
    placeholder: "Select Language",
    options: [
      { value: "ar", label: "Arabic" },
      { value: "en", label: "English" },
    ],
    value: ["ar", "en"],
  },
  {
    name: "gender",
    label: "Gender",
    type: "radio",
    placeholder: "Select Gender",
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
    ],
    value: ["male", "female"],
  },
  {
    name: "image_url",
    label: "Image",
    type: "file",
    placeholder: "User Image",
  },
];

export default userFields;
